import React from 'react';
import HeroSection from '../components/HeroSection/HeroSection';
import Services from '../components/Services/Services';
import Differentials from '../components/Differentials/Differentials';
import ESocial from '../components/ESocial/ESocial';
import Trainings from '../components/Trainings/Trainings';
import ComplementaryExams from '../components/ComplementaryExams/ComplementaryExams';
import About from '../components/About/About';
import LandingPages from '../components/LandingPages/LandingPages';
import ContactForm from '../components/ContactForm/ContactForm';

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <Services />
      <Differentials />
      <ESocial />
      <LandingPages />
      <Trainings />
      <ComplementaryExams />
      <About />
      <ContactForm />
    </>
  );
};

export default HomePage;
